function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack, IconButton, tempo, Link, DeezerLogo, Box, Text, SimpleGrid } from '@tempo/core';
import { useLandingPageScales } from '.';
export const LandingFooter = (_param)=>{
    var { children } = _param, stackProps = _object_without_properties(_param, [
        "children"
    ]);
    const { containerGutters, interSectionSpacing } = useLandingPageScales();
    return /*#__PURE__*/ _jsx(Stack, _object_spread_props(_object_spread({
        borderTop: "solid 1px",
        borderColor: "border.neutral.primary.default",
        direction: "column",
        spacing: [
            16,
            null,
            20
        ],
        fontSize: "md",
        pb: [
            5,
            '120px'
        ],
        pl: containerGutters,
        pr: containerGutters,
        mt: interSectionSpacing,
        pt: [
            5,
            10
        ],
        lineHeight: "base",
        width: "100%"
    }, stackProps), {
        children: children
    }));
};
export const LandingFooterSocialNetwork = tempo(Stack);
LandingFooterSocialNetwork.defaultProps = {
    spacing: 3,
    direction: 'row',
    ms: {
        base: 0,
        md: '-15px'
    }
};
export const LandingFooterSocialNetworkIcon = (_param)=>{
    var { icon } = _param, props = _object_without_properties(_param, [
        "icon"
    ]);
    return /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
        as: "a",
        variant: "ghost",
        target: "_blank"
    }, props), {
        children: icon
    }));
};
export const LandingFooterBottom = (_param)=>{
    var { logo, socialIcons, languageSelector, copyright } = _param, stackProps = _object_without_properties(_param, [
        "logo",
        "socialIcons",
        "languageSelector",
        "copyright"
    ]);
    return /*#__PURE__*/ _jsxs(SimpleGrid, _object_spread_props(_object_spread({
        columns: {
            base: 1,
            md: 3
        },
        gap: {
            base: 15,
            md: 0
        },
        alignItems: "center",
        w: "100%"
    }, stackProps), {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                order: {
                    base: 1,
                    md: 2
                },
                w: "fit-content",
                justifySelf: "center",
                children: typeof logo !== 'undefined' ? logo : /*#__PURE__*/ _jsx(DeezerLogo, {})
            }),
            /*#__PURE__*/ _jsx(Box, {
                order: {
                    base: 2,
                    sm: 1
                },
                justifySelf: {
                    base: 'center',
                    md: 'start'
                },
                children: socialIcons
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                order: 3,
                direction: "row",
                alignItems: "center",
                justifySelf: {
                    base: 'center',
                    md: 'end'
                },
                children: [
                    copyright ? copyright : /*#__PURE__*/ _jsxs(Text, {
                        color: "text.neutral.secondary.default",
                        flexShrink: 0,
                        children: [
                            "© ",
                            new Date().getFullYear(),
                            " Deezer"
                        ]
                    }),
                    languageSelector
                ]
            })
        ]
    }));
};
export const LandingFooterLink = tempo(Link, {
    baseStyle: {
        w: 'fit-content',
        color: 'text.neutral.secondary.default'
    }
});
export const LandingFooterLinks = tempo(Stack);
LandingFooterLinks.defaultProps = {
    justifyContent: 'space-between',
    spacing: {
        base: 8,
        sm: 6,
        md: 10
    },
    direction: {
        base: 'column',
        sm: 'row'
    }
};
export const LandingFooterLinkGroup = (_param)=>{
    var { label, children } = _param, stackProps = _object_without_properties(_param, [
        "label",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        direction: "column",
        spacing: "6",
        w: "fit-content"
    }, stackProps), {
        children: [
            typeof label === 'string' ? /*#__PURE__*/ _jsx(Text, {
                fontWeight: "semibold",
                children: label
            }) : label,
            /*#__PURE__*/ _jsx(Stack, {
                w: "fit-content",
                direction: "column",
                spacing: "4",
                children: children
            })
        ]
    }));
};
export const LandingFooterCategoryLink = (_param)=>{
    var { children } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(Text, {
            fontWeight: "semibold",
            children: children
        })
    }));
};

//# sourceMappingURL=LandingFooter.js.map